__turbopack_context__.v({
  "dropdown": "dropdown-component-module-scss-module__0wsToW__dropdown",
  "dropdown--disabled": "dropdown-component-module-scss-module__0wsToW__dropdown--disabled",
  "dropdown--opened": "dropdown-component-module-scss-module__0wsToW__dropdown--opened",
  "dropdown--show-on-top": "dropdown-component-module-scss-module__0wsToW__dropdown--show-on-top",
  "dropdown--stretch-to-parent": "dropdown-component-module-scss-module__0wsToW__dropdown--stretch-to-parent",
  "dropdown__content": "dropdown-component-module-scss-module__0wsToW__dropdown__content",
  "dropdown__icon": "dropdown-component-module-scss-module__0wsToW__dropdown__icon",
  "dropdown__list": "dropdown-component-module-scss-module__0wsToW__dropdown__list",
  "dropdown__list-item": "dropdown-component-module-scss-module__0wsToW__dropdown__list-item",
  "dropdown__list-item--selected": "dropdown-component-module-scss-module__0wsToW__dropdown__list-item--selected",
  "dropdown__main-button": "dropdown-component-module-scss-module__0wsToW__dropdown__main-button",
  "dropdown__selected-item": "dropdown-component-module-scss-module__0wsToW__dropdown__selected-item",
});
